import context from '@truckdown/systems';
import { defineComponent, ref, Ref, onMounted, onUnmounted, computed } from 'vue';
import { Constants } from '../../constants';
//NOTE: transactions are not registered
import { ServiceRequestStatusChecker } from '@truckdown/servicetransactions/ServiceRequestStatusChecker';

interface RequestStatus {
    vendor: {
        isActive: boolean;
        new: number;
        active: number;
    },
    fleet: {
        isActive: boolean;
        new: number;
        active: number;
    }
}

interface IProps {
    status: RequestStatus
}

interface IData {
    showMenu: Ref<boolean>;
    requestsCounts: Ref<RequestStatus>;
}


const getData = function (props: IProps) {
    return {
        showMenu: ref<boolean>(false),
        requestsCounts: ref<RequestStatus>(props.status)
    } as IData;
}

const getNewCount = function (counts: RequestStatus) {
    return (counts.vendor.isActive ? counts.vendor.new : 0)
        + (counts.fleet.isActive ? counts.fleet.new : 0);
}

const getActiveCount = function (counts: RequestStatus) {
    return (counts.vendor.isActive ? counts.vendor.active : 0)
        + (counts.fleet.isActive ? counts.fleet.active : 0);
}

const getComputed = function (data: IData) {
    return {
        badgeCount: computed(() => {
            return getNewCount(data.requestsCounts.value);
        }),
        linkTooltip: computed(() => {
            return 'Service Requests\n   New: ' + getNewCount(data.requestsCounts.value) + '\n   Active: ' + getActiveCount(data.requestsCounts.value);
        }),
        isMenu: computed(() => {
            return data.requestsCounts.value.vendor.isActive && data.requestsCounts.value.fleet.isActive;
        }),
        linkUrl: computed(() => {
            if (data.requestsCounts.value.vendor.isActive) {
                return '/servicerequests/vendor';
            }
            return '/servicerequests/fleet';
        })
    }
}

const getMethods = function (props: IProps, data: IData) {
    return {
        toggleMenu: function () {
            data.showMenu.value = !data.showMenu.value;
        },
        closeMenu: function () {
            data.showMenu.value = false;
        }
    }
}

export default defineComponent({
    name: 'requests-link',
    props: {
        status: {
            type: Object as () => RequestStatus,
            required: true
        }
    },
    setup: function (props, ctx) {
        let data = getData(props);
        let computed = getComputed(data);
        let methods = getMethods(props, data);

        let handler = async function () {
            try {
                let checker = new ServiceRequestStatusChecker(context);
                let res = await checker.getStatus();
                if (res) {
                    data.requestsCounts.value = res;
                }
            } catch (err) {
                console.log(err);
            }
        }

        onMounted(() => {
            context.events.on(Constants.Events.ReceivedEvent, handler);
        })

        onUnmounted(() => {
            context.events.off(Constants.Events.ReceivedEvent, handler);
        })

        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});